import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component, render } from "preact";
import 'regenerator-runtime';
import { Tokens } from "../../api/Client";
import { CardBrand } from "../../util/CardBrand";
import { ValidationError } from "../../util/FormValidation";
export class CardTokenizerComponent extends Component {
    constructor() {
        super();
        this.state = {
            storeId: null,
            sequence: null,
            cardno: null,
            holdername: null,
            expiremonth: null,
            expireyear: null,
            cvc: null,
            show: false,
            processing: false,
            errors: new ValidationError()
        };
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        document.querySelectorAll('[data-modal-ref="CardTokenizerModal"]').forEach(e => {
            e.addEventListener('click', clickEvt => {
                const elm = clickEvt.target;
                const storeId = elm.closest('button')?.getAttribute('data-store-id');
                const sequence = elm.closest('button')?.getAttribute('data-cardsequence');
                console.debug(`open CardTokenizerModal [store_id => ${storeId}]`);
                this.openModal(Number(storeId), Number(sequence));
            });
        });
    }
    render() {
        // 有効期限(月)のDOM
        let expireMonthOptions = [];
        for (let monthIdx = 1; monthIdx < 13; monthIdx++) {
            const monthVal = `0${monthIdx}`.slice(-2);
            expireMonthOptions.push(_jsx("option", Object.assign({ value: monthVal, selected: this.state.expiremonth == monthVal }, { children: monthVal }), void 0));
        }
        // 有効期限(年)のDOM
        let expireYearOption = [];
        const currentDate = new Date();
        for (let yearIdx = 0; yearIdx < 10; yearIdx++) {
            const yearVal = `${currentDate.getFullYear() + yearIdx}`;
            expireYearOption.push(_jsx("option", Object.assign({ value: yearVal, selected: this.state.expireyear === yearVal }, { children: yearVal }), void 0));
        }
        return (_jsxs("div", Object.assign({ class: this.wrapperClassName() }, { children: [_jsx("div", { class: "modal-background", onClick: () => this.closeModal() }, void 0),
                _jsxs("div", Object.assign({ class: "modal-content" }, { children: [_jsx("img", { class: "icon icon__modal_close", src: "/assets/images/modal_close_icon.svg", onClick: () => this.closeModal() }, void 0),
                        _jsx("div", Object.assign({ class: "modal__header" }, { children: _jsx("h3", Object.assign({ class: "title" }, { children: "\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u767B\u9332" }), void 0) }), void 0),
                        _jsxs("div", Object.assign({ class: "modal__body form-container" }, { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30AB\u30FC\u30C9\u756A\u53F7" }), void 0),
                                        _jsx("input", { type: "text", class: `input ${this.hasError('cardno') ? 'is-danger' : ''}`, value: this.state.cardno ?? '', name: "cardno", maxLength: 16, onInput: this.handleChange }, void 0), this.messages('cardno')] }), void 0),
                                _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30AB\u30FC\u30C9\u540D\u7FA9\u4EBA" }), void 0),
                                        _jsx("input", { type: "text", class: `input ${this.hasError('holdername') ? 'is-danger' : ''}`, value: this.state.holdername ?? '', name: "holdername", onInput: this.handleChange, maxLength: 50 }, void 0), this.messages('holdername')] }), void 0),
                                _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u6709\u52B9\u671F\u9650" }), void 0),
                                        _jsxs("div", Object.assign({ class: "control flex flex__align_item_center" }, { children: [_jsx("div", Object.assign({ class: `select ${this.hasError('expiremonth') ? 'is-danger' : ''}` }, { children: _jsxs("select", Object.assign({ name: "expiremonth", onInput: this.handleChange }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u6708" }), void 0), expireMonthOptions] }), void 0) }), void 0),
                                                _jsx("i", { class: "fas fa-slash fa-rotate-90 mx2" }, void 0),
                                                _jsx("div", Object.assign({ class: `select ${this.hasError('expireyear') ? 'is-danger' : ''}` }, { children: _jsxs("select", Object.assign({ name: "expireyear", onInput: this.handleChange }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u5E74" }), void 0), expireYearOption] }), void 0) }), void 0)] }), void 0), this.messages('expiremonth'), this.messages('expireyear')] }), void 0),
                                _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9" }), void 0),
                                        _jsx("input", { type: "number", class: `input ${this.hasError('cvc') ? 'is-danger' : ''}`, name: "cvc", value: this.state.cvc ?? '', onInput: this.handleChange, maxLength: 4 }, void 0), this.messages('cvc')] }), void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: "modal__footer" }, { children: [_jsx("button", Object.assign({ type: "button", class: "button button__secondary button__md button__block mr2", onClick: () => this.closeModal() }, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB" }), void 0),
                                _jsx("button", Object.assign({ type: "button", class: "button button__danger button__md button__block ml2", onClick: () => this.handleRegister(), disabled: this.state.processing }, { children: "\u767B\u9332\u3059\u308B" }), void 0)] }), void 0)] }), void 0)] }), void 0));
    }
    wrapperClassName() {
        let classes = ['modal', 'is-clipped'];
        if (this.state.show === true) {
            classes.push('is-active');
        }
        return classes.join(' ');
    }
    handleChange(event) {
        let state = this.state;
        const target = event.target;
        const stateName = target.getAttribute('name');
        // @ts-ignore
        state[stateName] = target.value;
        this.setState(state);
    }
    closeModal() {
        this.setState({
            cardno: null,
            holdername: null,
            expiremonth: null,
            expireyear: null,
            cvc: null,
            errors: new ValidationError(),
            show: false
        });
    }
    openModal(storeId, sequence) {
        this.setState({
            storeId: storeId,
            sequence: sequence,
            show: true
        });
    }
    handleRegister() {
        const errors = CardBrand.validate(this.state);
        this.setState({ errors: errors });
        if (errors.hasErrors() === false) {
            this.setState({ processing: true });
            const cardBrandType = CardBrand.detectCardBrand(this.state.cardno);
            Tokens.getStoreType(this.state.storeId, cardBrandType).then(response => {
                const { storeId, storeIdentifier, storeSecrets, storeType } = response.data;
                document.addEventListener('--get-token', e => {
                    const evt = e;
                    const tokens = evt.detail.tokens;
                    Tokens.registerCard(storeId, tokens, cardBrandType, this.state.sequence).then(_ => {
                        alert('カードを登録しました');
                        location.reload();
                    }).catch(e => {
                        alert('カードの登録に失敗しました。お手数ですが暫く時間を置くか、違うカードで登録してください。');
                        this.setState({ processing: false });
                        throw e;
                    });
                }, { once: true });
                Tokens.getToken(this.state, storeType, storeId, storeIdentifier, storeSecrets).catch(e => {
                    this.setState({ processing: false });
                    alert(e);
                    throw e;
                });
            }).catch(e => {
                // 取り扱いできないカードブランドなのでエラーにする
                let errors = this.state.errors;
                errors.add('cardno', '取り扱いできないカードブランドです。お手数ですが、加盟店様へご利用可能なブランドを問合せ下さい。');
                this.setState({
                    errors: errors,
                    processing: false
                });
                throw e;
            });
        }
    }
    hasError(field) {
        return this.state.errors.hasError(field);
    }
    messages(field) {
        return this.state.errors.getMessage(field).map(m => (_jsx("p", Object.assign({ class: "help is-danger" }, { children: m }), void 0)));
    }
}
window.addEventListener('load', () => {
    const mountTo = document.querySelector('#CardTokenizerComponent');
    if (mountTo) {
        render(_jsx(CardTokenizerComponent, {}, void 0), mountTo);
    }
});
